var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentsCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 0.666504H2.33329C1.41663 0.666504 0.674959 1.4165 0.674959 2.33317L0.666626 17.3332L3.99996 13.9998H15.6666C16.5833 13.9998 17.3333 13.2498 17.3333 12.3332V2.33317C17.3333 1.4165 16.5833 0.666504 15.6666 0.666504Z",
    fill: "#272A32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.674959 2.33317L1.17496 2.33345V2.33317H0.674959ZM0.666626 17.3332L0.166626 17.3329L0.165955 18.5409L1.02018 17.6867L0.666626 17.3332ZM3.99996 13.9998V13.4998H3.79285L3.64641 13.6463L3.99996 13.9998ZM15.6666 0.166504H2.33329V1.1665H15.6666V0.166504ZM2.33329 0.166504C1.13723 0.166504 0.174959 1.14363 0.174959 2.33317H1.17496C1.17496 1.68938 1.69603 1.1665 2.33329 1.1665V0.166504ZM0.174959 2.33289L0.166626 17.3329L1.16663 17.3334L1.17496 2.33345L0.174959 2.33289ZM1.02018 17.6867L4.35351 14.3534L3.64641 13.6463L0.313073 16.9796L1.02018 17.6867ZM3.99996 14.4998H15.6666V13.4998H3.99996V14.4998ZM15.6666 14.4998C16.8594 14.4998 17.8333 13.526 17.8333 12.3332H16.8333C16.8333 12.9737 16.3072 13.4998 15.6666 13.4998V14.4998ZM17.8333 12.3332V2.33317H16.8333V12.3332H17.8333ZM17.8333 2.33317C17.8333 1.14036 16.8594 0.166504 15.6666 0.166504V1.1665C16.3072 1.1665 16.8333 1.69265 16.8333 2.33317H17.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentsCount);
export default __webpack_public_path__ + "static/media/commentsCount.277d523371290637ae7481a94c93026d.svg";
export { ForwardRef as ReactComponent };